/*
 * Handles the options toggles for the reviewer UI list
 */

define([
  "marionette",
  "modules/reviewer/reviewerListToggle/template/reviewerListToggleTemplate.html",
], function (Marionette, ReviewerListToggleTemplate) {
  var ReviewerListToggleView = {};

  ReviewerListToggleView.reviewerListToggleView = Marionette.ItemView.extend({
    template: ReviewerListToggleTemplate,
    events: {
      "click #notStartedTasks": function () {
        this.trigger("show:not:started");
      },
      "click #inProgressTasks": function () {
        this.trigger("show:in:progress");
      },
      "click #completedTasks": function () {
        this.trigger("show:completed");
      },
    },
  });

  return ReviewerListToggleView;
});
